"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZuoraGetPaymentMethodSchema = void 0;
exports.ZuoraGetPaymentMethodSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        sonosId: {
            type: 'string',
            minLength: 1
        }
    },
    required: [
        'sonosId'
    ],
    type: 'object'
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoienVvcmEtZ2V0LXBheW1lbnQtbWV0aG9kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2RvbXMvc2NoZW1hcy96dW9yYS96dW9yYS1nZXQtcGF5bWVudC1tZXRob2QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwyQkFBMkIsR0FBRztJQUN2QyxPQUFPLEVBQUUseUNBQXlDO0lBQ2xELFVBQVUsRUFBRTtRQUNWLE9BQU8sRUFBRTtZQUNQLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDYjtLQUNGO0lBQ0QsUUFBUSxFQUFFO1FBQ1IsU0FBUztLQUNWO0lBQ0QsSUFBSSxFQUFFLFFBQVE7Q0FDZixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IFp1b3JhR2V0UGF5bWVudE1ldGhvZFNjaGVtYSA9IHtcbiAgICAkc2NoZW1hOiAnaHR0cDovL2pzb24tc2NoZW1hLm9yZy9kcmFmdC0wNy9zY2hlbWEjJyxcbiAgICBwcm9wZXJ0aWVzOiB7XG4gICAgICBzb25vc0lkOiB7XG4gICAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgICBtaW5MZW5ndGg6IDFcbiAgICAgIH1cbiAgICB9LFxuICAgIHJlcXVpcmVkOiBbXG4gICAgICAnc29ub3NJZCdcbiAgICBdLFxuICAgIHR5cGU6ICdvYmplY3QnXG4gIH1cbiAgIl19